export default function useGetTotalPrice() {
  const getTotalPrice = (productsArr) => {
    // Use the reduce method to sum up the prices, considering discount_price if available
    return productsArr.reduce((accumulator, currentObject) => {
      // Use discount_price if it exists, otherwise use price
      const priceToUse = currentObject.discount_price !== null ? currentObject.discount_price : currentObject.price;

      if (isNaN(priceToUse)) return 0;

      // Add the price to the accumulator
      return accumulator + priceToUse;
    }, 0); // 0 is the initial value of the accumulator
  };

  return {
    getTotalPrice,
  };
}
